import { Dispatch, useReducer } from 'react';

export enum PreAuthStep {
  idle = 'idle', // Initial state
  mfaRequired = 'mfa_required', // Show MFA widget
  waiting = 'waiting', // Waiting for pusher event to be received
}

type PreAuthInternalState = {
  step: PreAuthStep;
  channelName: string | null;
  mfaProps: MfaWidgetProps | null;
};

export type MfaWidgetProps = {
  aeroPassUserUuid: string;
  token: string;
  jobId: string;
  connectionId: string;
};

export type PreAuthAction =
  | { type: 'MFA_SUCCESS' }
  | { type: 'RESET' }
  | { type: 'SHOW_MFA'; mfaProps: MfaWidgetProps }
  | { type: 'START_WAITING'; channelName: string };

const preAuthReducer = (state: PreAuthInternalState, action: PreAuthAction): PreAuthInternalState => {
  switch (action.type) {
    case 'START_WAITING':
      return {
        ...state,
        step: PreAuthStep.waiting,
        channelName: action.channelName,
      };

    case 'SHOW_MFA':
      return {
        ...state,
        step: PreAuthStep.mfaRequired,
        mfaProps: action.mfaProps,
      };

    case 'MFA_SUCCESS':
      return {
        ...state,
        step: PreAuthStep.waiting,
        mfaProps: null,
      };

    case 'RESET':
      return {
        step: PreAuthStep.idle,
        channelName: null,
        mfaProps: null,
      };

    default:
      return state;
  }
};

const initialState: PreAuthInternalState = {
  step: PreAuthStep.idle,
  channelName: null,
  mfaProps: null,
};

export const usePreAuthReducer = (): [PreAuthInternalState, Dispatch<PreAuthAction>] =>
  useReducer(preAuthReducer, initialState);
